import React from "react";
import styled from "styled-components";

import { Line } from "../../components/Line";
import { Title } from "../../components/Title";

const SettingsStyle = styled.div`
    padding: 60px 100px 0 100px;
`;

const ContentStyle = styled.div`
    padding: 10px 0 0 0;
`;

export const SettingsItem = props =>
    <SettingsStyle>
        <Title size="medium" value={props.title} />
        <ContentStyle>
            {props.children}
            <Line />
        </ContentStyle>
    </SettingsStyle>;